import { Nav, Tab } from 'react-bootstrap';
import InstructorCard, { InstructorCardProps } from '../InstructorCard';
import HTMLParsedContent from '../HTMLParsedContent';
import { Styles } from './styles';
import SocialMedias from '../SocialMedias';

export type Curriculum = {
  title: string;
  curriculumItem: {
    title: string;
    duration?: string;
  }[];
};

export type CourseTabBoxProps = {
  curriculum: Curriculum[];
  description: string;
  instructors: InstructorCardProps[];
  url?: string;
  title?: string;
};

const CourseTabBox: React.FC<CourseTabBoxProps> = ({
  curriculum,
  description,
  instructors,
  url,
  title,
}) => {
  const isOneInstructor = instructors.length === 1;

  return (
    <Styles>
      <Tab.Container defaultActiveKey="overview">
        <Nav className="flex-column">
          <Nav.Item>
            <Nav.Link eventKey="overview">Visão geral</Nav.Link>
          </Nav.Item>
          {curriculum.length > 0 && (
            <Nav.Item>
              <Nav.Link eventKey="curriculum">Ementa</Nav.Link>
            </Nav.Item>
          )}
          {instructors.length > 0 && (
            <Nav.Item>
              <Nav.Link eventKey="instructor">
                {isOneInstructor ? 'Instrutor' : 'Instrutores'}
              </Nav.Link>
            </Nav.Item>
          )}
        </Nav>
        <Tab.Content>
          <Tab.Pane eventKey="overview" className="overview-tab">
            <h2 style={{ fontSize: '20px' }}>Sobre o curso</h2>
            <HTMLParsedContent
              className="text-content"
              content={description
                ?.replace(/<li>/g, '<li><i class="las la-arrow-right"></i>')
                .replace(/<hr/g, '<hr class="mx-auto w-75" ')
                .replace(/<p style="margin-left:0px;">&nbsp;<\/p>/g, '')
                .replace(
                  /<p style="margin-left:0px;">/g,
                  '<p style="margin-left: 0px; margin-bottom: 16px;">',
                )}
            />
            <h5 className="text-content heading">Compartilhe este curso</h5>
            <SocialMedias url={url} title={title} />
          </Tab.Pane>
          <Tab.Pane eventKey="curriculum" className="curriculum-tab">
            {/* {curriculum.description && <HTMLParsedContent className="text-content" content={curriculum.description} />} */}
            {curriculum.length > 0 && (
              <div className="course-element">
                <h2 style={{ fontSize: '20px' }}>Conteúdo do curso</h2>
                {curriculum?.map((item) => {
                  if (item.curriculumItem.length === 0) return null;
                  return (
                    <div key={item.title} className="course-item">
                      <button className="course-button active">{item.title}</button>
                      <div className="course-content show">
                        <ul className="list-unstyled">
                          {item.curriculumItem.map((curriculumItem) => {
                            if (!curriculumItem.title) return null;
                            return (
                              <li key={curriculumItem.title}>
                                <span className="play-icon">
                                  <i className="las la-check"></i>
                                </span>
                                <span className="lecture-title">{curriculumItem.title}</span>
                                {curriculumItem.duration && (
                                  <span className="lecture-duration">
                                    {curriculumItem.duration}
                                  </span>
                                )}
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </Tab.Pane>
          <Tab.Pane eventKey="instructor" className="instructor-tab">
            <h2 style={{ fontSize: '20px' }}>Instrutores do curso</h2>
            {instructors.length > 0 &&
              instructors.map((instructor) => {
                return (
                  <InstructorCard key={instructor.name} {...(instructor as InstructorCardProps)} />
                );
              })}
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </Styles>
  );
};

export default CourseTabBox;
